import React from 'react'
import { MetricCard } from './MetricCard'
import './MetricsGrid.css'

interface MetricsGridProps {
  investableAssets: number
  depositsOrCash: number
  lendingOrLiabilities: number
  trustScore: number
}

export const MetricsGrid: React.FC<MetricsGridProps> = ({
  investableAssets,
  depositsOrCash,
  lendingOrLiabilities,
  trustScore
}) => {
  return (
    <div className="metrics-grid">
      {/* <MetricCard
        icon={
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <polyline points="23 6 13.5 15.5 8.5 10.5 1 18" />
            <polyline points="17 6 23 6 23 12" />
          </svg>
        }
        value={totalRelationshipValue}
        label="Total Relationship Value"
        iconColor="#3b82f6"
        formatType="currency"
      /> */}

      <MetricCard
        icon={
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <rect x="2" y="4" width="20" height="16" rx="2" />
            <path d="M7 15h0M2 9.5h20" />
          </svg>
        }
        value={investableAssets}
        label="Investable Assets"
        iconColor="#10b981"
        formatType="currency"
      />

      <MetricCard
        icon={
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <line x1="12" y1="1" x2="12" y2="23" />
            <path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6" />
          </svg>
        }
        value={depositsOrCash}
        label="Deposits / Cash"
        iconColor="#a78bfa"
        formatType="currency"
      />

      <MetricCard
        icon={
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <rect x="1" y="4" width="22" height="16" rx="2" ry="2" />
            <line x1="1" y1="10" x2="23" y2="10" />
          </svg>
        }
        value={lendingOrLiabilities}
        label="Lending / Liabilities"
        iconColor="#f97316"
        formatType="currency"
      />

      <MetricCard
        icon={
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
          </svg>
        }
        value={trustScore}
        label="Data Trust Score"
        iconColor="#10b981"
        formatType="percentage"
      />
    </div>
  )
}
